import { useLogin } from "@refinedev/core";
import { Alert, Button, Field } from "@opowiedzo/ui";
import { useState } from "react";

import type { LoginValues } from "@/providers/authProvider";

export function LoginPage() {
  const { mutate: login, isPending, data } = useLogin<LoginValues>();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");

  const blad = data?.success === false ? data.error?.message : undefined;

  return (
    <main className="view-enter mx-auto flex min-h-screen max-w-105 flex-col justify-center px-6">
      <h1 className="font-display text-2xl font-semibold text-ink">Opowiedzo - panel</h1>
      <p className="mt-1 mb-6 text-md text-ink-soft">
        Dostęp wyłącznie dla zespołu. Każde wejście i każda akcja są zapisywane.
      </p>

      <form
        className="flex flex-col gap-4"
        onSubmit={(event) => {
          event.preventDefault();
          login({ email, password, totp_code: totpCode || undefined });
        }}
      >
        <Field
          label="Adres e-mail"
          name="email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <Field
          label="Hasło"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <Field
          label="Kod z aplikacji"
          name="totp_code"
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="123 456"
          hint="Sześć cyfr z aplikacji uwierzytelniającej. Na produkcji obowiązkowy."
          value={totpCode}
          onChange={(event) => setTotpCode(event.target.value)}
        />

        {blad && <Alert tone="error">{blad}</Alert>}

        <Button type="submit" variant="primary" fullWidth disabled={isPending}>
          {isPending ? "Sprawdzam..." : "Zaloguj"}
        </Button>
      </form>
    </main>
  );
}
